import React from 'react'

export const AppState = React.createContext({
  authed: false,
  user: null,
  loading: true
})



// WEBPACK FOOTER //
// ./src/helpers/context.js